$(function () {
  // =============================== api ===============================
  var projectId = $('#project').data('sf-id');

  var domain = 'py3-api.citiesocial.com';
  var collection_api =
    '//' + domain + '/early-bird/visualized-projects/' + projectId + '/';

  $.get(collection_api, function (project) {
    const PROJECT_NOT_BEGIN = 'PROJECT_NOT_BEGIN';
    const PROJECT_AVAILABLE = 'PROJECT_AVAILABLE';
    const PROJECT_FINISHED = 'PROJECT_FINISHED';
    var projectStatus = getProjectStatus(project);

    function getProjectStatus(project) {
      var projectStartAt = Date.parse(project.available_at);
      var projectEndAt = Date.parse(project.deadline);

      if (Date.now() < projectStartAt) {
        return PROJECT_NOT_BEGIN;
      } else if (projectStartAt < Date.now() && Date.now() < projectEndAt) {
        return PROJECT_AVAILABLE;
      } else {
        return PROJECT_FINISHED;
      }
    }
    
    // 分類
    $('#category').html(project.category?.menu_collection?.title);

    // =============================== 方案 cs-early-bird-plans.liquid ===============================
    var groupPlans = project.group_plans;

    var $blockSection = $('#block-section');

    const IS_SHOW_PLAN_PRICE = project.is_show_plans;

    groupPlans = getPlanGroupInStockOrNot(groupPlans);

    var sortedGroups = sortPlanGroupByPositionAndIsSoldOut(groupPlans);

    sortedGroups.forEach(function renderByBlock(group) {
      if (group.isGroup) {
        var selectedPlan = getDefaultSelectedPlan(group.data);

        // render the initial plan group layout
        var $planBlock = $(
          renderByPlanGroup(
            projectStatus,
            group.is_sold_out,
            selectedPlan,
            sortPlansByIsSoldOut(group.data)
          )
        );
        $blockSection.append($planBlock);

        // handle buy button click
        var handleClickFunction = generateClickFunction(
          selectedPlan.shopify_variant_id
        );
        $planBlock.find('.add-plan-btn').on('click', handleClickFunction);

        // eslint-disable-next-line no-inner-declarations
        function generateClickFunction(variantId) {
          return function handleClick() {
            Citiesocial.cartManager.quickAddToCart(null, variantId);
          };
        }

        // update the plan block information with the selected plan
        $planBlock.find('.single-option-selector').on('change', handleSelect);

        // eslint-disable-next-line no-inner-declarations
        function handleSelect(e) {
          // update selectedPlan
          selectedPlan = group.data.find(function findPlanWithId(plan) {
            return plan.shopify_variant_id == e.target.value;
          });

          // update UI
          $planBlock
            .find('.plan-img')
            .attr('src', selectedPlan.image_url)
            .attr('alt', selectedPlan.plan_title);
          $planBlock.find('.plan-title').html(selectedPlan.plan_title);
          $planBlock.find('.plan-price').html(`NT$ ${selectedPlan.price}`);
          $planBlock
            .find('.plan-market-price')
            .html(`NT$ ${selectedPlan.compare_at_price}`);
          $planBlock
            .find('.limit-count')
            .html(selectedPlan.initial_inventory_quantity);
          $planBlock
            .find('.plan-ordered')
            .html(
              `已售出 ${formatProductSoldCount(
                selectedPlan.product_sold_count,
                selectedPlan.initial_inventory_quantity
              )} 組`
            );
          $planBlock.find('.plan-content').html(selectedPlan.content);
          $planBlock.find('.reward-point').html(selectedPlan.reward_point);
          if (selectedPlan.reward_point <= 0) {
            $planBlock.find('.unlock-title').hide();
            $planBlock.find('.unlock-info').hide();
          }
          $planBlock
            .find('.shipout')
            .html(
              `預計出貨時間：${formatShipAt(
                selectedPlan.ship_at,
                selectedPlan.is_estimated_date_using_general_rule
              )}`
            );
          $planBlock
            .find('.add-plan-btn')
            .attr('data-variant-id', selectedPlan.shopify_variant_id);

          // update event listener
          $planBlock.find('.add-plan-btn').off('click', handleClickFunction);
          handleClickFunction = generateClickFunction(
            selectedPlan.shopify_variant_id
          );
          $planBlock.find('.add-plan-btn').on('click', handleClickFunction);
        }
      } else {
        $blockSection.append(renderByPlan(projectStatus, group.data));
      }
    });

    function renderByPlanGroup(projectStatus, allSoldOut, selectedPlan, plans) {
      var title,
        buttonDisableClassName,
        btnText,
        planOptions,
        blockDisableClassName,
        initialInventoryQuantity,
        productSold;

      var shipAt = formatShipAt(
        selectedPlan.ship_at,
        selectedPlan.is_estimated_date_using_general_rule
      );

      if (projectStatus === PROJECT_NOT_BEGIN) {
        title = selectedPlan.group_name;
        initialInventoryQuantity = sumOfPlansInitialInventoryQuantity(plans);
        productSold = 0;
        buttonDisableClassName = 'disabled';
        btnText = '尚未開賣';
        blockDisableClassName = 'disabled';
        planOptions = '<option value="project_not_begin">尚未開賣</option>';
      } else if (projectStatus === PROJECT_AVAILABLE) {
        if (allSoldOut) {
          title = selectedPlan.group_name;
          initialInventoryQuantity = sumOfPlansInitialInventoryQuantity(plans);
          productSold = initialInventoryQuantity;
          buttonDisableClassName = 'disabled';
          btnText = '已售完';
          blockDisableClassName = 'disabled';
          planOptions = '<option value="sold_out">已售完</option>';
        } else {
          title = selectedPlan.plan_title;
          initialInventoryQuantity = selectedPlan.initial_inventory_quantity;
          productSold = selectedPlan.product_sold_count;
          buttonDisableClassName = '';
          btnText = '加入購物車 | <span class="buy-btn">30 天買貴退差價</span>';
          blockDisableClassName = '';
          planOptions = getPlanOptions(plans);
        }
      } else if (projectStatus === PROJECT_FINISHED) {
        title = selectedPlan.group_name;
        initialInventoryQuantity = sumOfPlansInitialInventoryQuantity(plans);
        productSold = initialInventoryQuantity;
        buttonDisableClassName = 'disabled';
        btnText = '預購結束';
        blockDisableClassName = 'disabled';
        planOptions = '<option value="project_finished">預購結束</option>';
      } else {
        // handle project status type error
      }

      var productSoldCount = formatProductSoldCount(productSold, initialInventoryQuantity);

      var planGroupBlockTemplate = `
        <div class="plan-block ${blockDisableClassName}">
          <img class="plan-img" src=${selectedPlan.image_url} alt=${
        selectedPlan.plan_title
      } />
          <div class="plan-info">
            <div class="plan-title">${title}</div>
            ${
              IS_SHOW_PLAN_PRICE
                ? `<div class="plan-price">
                    NT$ ${selectedPlan.price}
                  </div>
                  <del class="plan-market-price">NT$ ${selectedPlan.compare_at_price}</del>
                  <span class="plan-market">未來市價</span>
                  <br>`
                : ``
            }        
            <div class="plan-limit">
              限量 <span class="limit-count">${initialInventoryQuantity}</span> 組
            </div>
            <div class="plan-ordered">已售出 ${productSoldCount} 組</div>
            <div class="plan-content">${selectedPlan.content}</div>
            ${
              selectedPlan.reward_point
                ? `<div class="unlock-title">解鎖優惠</div>
                  <div class="unlock-info">
                    限量 <span class="limit-count">${initialInventoryQuantity}</span> 組購買後可額外獲得
                    <span class="reward-point">${selectedPlan.reward_point}</span> 元現金折價券
                  </div>`
                : ''
            }
            <div class="shipout">預計出貨時間：${shipAt}</div>
    
            <div class="styled-select util-mb-12">
              <select 
                class="single-option-selector"  
                data-selector-type="select"
                value="${selectedPlan.shopify_variant_id}"
              >
                ${planOptions}
              </select>
    
              <svg id="icon-dropdown-arrow" viewBox="0 0 32 32">
                <title>dropdown-arrow</title>
                <path class="path1" d="M-0 9.337c0-0.688 0.261-1.375 0.781-1.901 1.045-1.050 2.735-1.050 3.777 0l11.435 11.419 11.435-11.419c1.045-1.050 2.735-1.050 3.777 0 1.045 1.050 1.045 2.753 0 3.804l-13.322 13.32c-1.045 1.053-2.735 1.053-3.777 0l-13.325-13.32c-0.52-0.528-0.781-1.213-0.781-1.903z"></path>
              </svg>
            </div>
    
            <div 
              class="cs-productItem-imageWrapper-quckshopOverlay cs-productItem-quickAddWrapper-button add-plan-btn eb-basic-btn ${buttonDisableClassName}" 
              data-action="quick-add-to-cart" 
              data-variant-id="${selectedPlan.shopify_variant_id}"
            >
              ${btnText}
            </div>
    
          </div>
        </div>
      `;

      return planGroupBlockTemplate;
    }

    function renderByPlan(projectStatus, plan) {
      var buttonDisableClassName,
        btnText,
        blockDisableClassName,
        initialInventoryQuantity,
        productSold,
        shipAt;

      shipAt = formatShipAt(
        plan.ship_at,
        plan.is_estimated_date_using_general_rule
      );

      if (projectStatus === PROJECT_NOT_BEGIN) {
        initialInventoryQuantity = plan.initial_inventory_quantity;
        productSold = 0;
        buttonDisableClassName = 'disabled';
        btnText = '尚未開賣';
        blockDisableClassName = 'disabled';
      } else if (projectStatus === PROJECT_AVAILABLE) {
        if (plan.is_sold_out) {
          initialInventoryQuantity = plan.initial_inventory_quantity;
          productSold = initialInventoryQuantity;
          buttonDisableClassName = 'disabled';
          btnText = '已售完';
          blockDisableClassName = 'disabled';
        } else {
          initialInventoryQuantity = plan.initial_inventory_quantity;
          productSold = plan.product_sold_count;
          buttonDisableClassName = '';
          btnText = '加入購物車';
          blockDisableClassName = '';
        }
      } else if (projectStatus === PROJECT_FINISHED) {
        initialInventoryQuantity = plan.initial_inventory_quantity;
        productSold = initialInventoryQuantity;
        buttonDisableClassName = 'disabled';
        btnText = '預購結束';
        blockDisableClassName = 'disabled';
      } else {
        // handle project status type error
      }

      var productSoldCount = formatProductSoldCount(productSold, initialInventoryQuantity);

      var planBlock = `
        <div class="plan-block ${blockDisableClassName}">
          <img class="plan-img" src=${plan.image_url} alt=${plan.plan_title} />
          <div class="plan-info">
            <div class="plan-title">${plan.plan_title}</div>
            ${
              IS_SHOW_PLAN_PRICE
                ? `<div class="plan-price">
                    NT$ ${plan.price}
                  </div>
                  <del class="plan-market-price">NT$ ${plan.compare_at_price}</del>
                  <span class="plan-market">未來市價</span>
                  <br>`
                : ``
            }
            <div class="plan-limit">
              限量 <span class="limit-count">${initialInventoryQuantity}</span> 組
            </div>
            <div class="plan-ordered">已售出 ${productSoldCount} 組</div>
            <div class="plan-content">${plan.content}</div>
            ${
              plan.reward_point
                ? `<div class="unlock-title">解鎖優惠</div>
                  <div class="unlock-info">
                    限量 <span class="limit-count">${initialInventoryQuantity}</span> 組購買後可額外獲得
                    <span class="reward-point">${plan.reward_point}</span> 元現金折價券
                  </div>`
                : ''
            }
    
            <div class="shipout">預計出貨時間：${shipAt}</div>
    
            <div 
              class="cs-productItem-imageWrapper-quckshopOverlay cs-productItem-quickAddWrapper-button add-plan-btn eb-basic-btn ${buttonDisableClassName}" 
              data-action="quick-add-to-cart" 
              data-variant-id="${plan.shopify_variant_id}"
              onclick="Citiesocial.cartManager.quickAddToCart(this, ${
                plan.shopify_variant_id
              })"
            >
              ${btnText}
            </div>
    
          </div>
        </div>
      `;

      return planBlock;
    }

    function getDefaultSelectedPlan(plans) {
      var plan = plans.find(function notSoldOut(plan) {
        return !plan.is_sold_out;
      });

      return plan || plans[0];
    }

    function getPlanGroupInStockOrNot(groups) {
      groups.forEach(function checkPlanGroupInStockOrNot(group) {
        if (group.isGroup) {
          group.is_sold_out = isPlansAllSoldOut(group.data);
        } else {
          group.is_sold_out = group.data.is_sold_out;
        }
      });

      return groups;
    }

    function sortPlanGroupByPositionAndIsSoldOut(groups) {
      groups = groups.sort(function sortByPosition(group1, group2) {
        if (group1.position < group2.position) return -1;
        else if (group1.position > group2.position) return 1;
        else return 0;
      });

      var inStockGroups = groups.filter(function inStockGroup(group) {
        return !group.is_sold_out;
      });

      var soldOutGroups = groups.filter(function soldOutGroup(group) {
        return group.is_sold_out;
      });

      return [...inStockGroups, ...soldOutGroups];
    }

    function isPlansAllSoldOut(plans) {
      var result = true;
      plans.forEach(function checkIsSoldOut(plan) {
        if (!plan.is_sold_out) {
          result = false;
        }
      });
      return result;
    }

    function formatShipAt(shipAt, isUsingGeneralRule) {
      if (isUsingGeneralRule) {
        return '下單後第 2 個工作日';
      } else if (shipAt == null) {
        return '未定';
      } else {
        return shipAt.replace(/-/g, '/');
      }
    }

    function formatProductSoldCount(count, max) {
      return count > max ? max : count;
    }

    function sortPlansByIsSoldOut(plans) {
      return [
        ...plans.filter(function notSoldOut(plan) {
          return !plan.is_sold_out;
        }),
        ...plans.filter(function soldOut(plan) {
          return plan.is_sold_out;
        }),
      ];
    }

    function getPlanOptions(plans) {
      var planOptions = '';
      plans.forEach(function getPlanOption(plan) {
        var option = `
        <option 
          value=${plan.shopify_variant_id} 
          ${plan.is_sold_out ? 'disabled' : ''}
        >
          ${plan.option_name} ${plan.is_sold_out ? '(已售完)' : ''}
        </option>`;
        planOptions = planOptions + option;
      });

      return planOptions;
    }

    function sumOfPlansInitialInventoryQuantity(plans) {
      return plans.reduce(function planInitialInventoryQuantityReducer(
        sum,
        plan
      ) {
        return sum + plan.initial_inventory_quantity;
      },
      0);
    }

    $('#loading-overlay').hide();
  });

});
